<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" />
      </template>
    </template>
    <main class="common-main law">
      <div class="item">
        <h2 class="common-title">特定商取引法に基づく表示</h2>
        <div class="item law">
          <table>
            <tr>
              <th>販売事業者</th>
              <td>株式会社ZINE</td>
            </tr>
            <tr>
              <th>運営統括責任者</th>
              <td>仁田坂淳史</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>〒151-0063 東京都渋谷区富ヶ谷2-17-17-501</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>03-6822-4373（受付時間：平日 09:00〜18:00）</td>

            </tr>
            <tr>
              <th>公開メールアドレス</th>
              <td>office@cancerwith.com</td>
            </tr>
            <tr>
              <th>ホームページURL</th>
              <td>https://cancerwith.com/</td>
            </tr>
            <tr>
              <th>お問い合わせフォーム</th>
              <td><a :href="contactUrl" target="_blank">お問い合わせフォーム</a></td>
            </tr>
            <tr>
              <th>問合せ受付時間</th>
              <td>問合せはお問い合わせフォームおよびメールにて24時間承ります。</td>
            </tr>
            <tr>
              <th>販売価格</th>
              <td>サービスごとに販売価格（消費税等含む）を設定し、<a href="https://cancerwith.com/#price">該当ページ</a>で表示します。</td>
            </tr>
            <tr>
              <th>商品代金以外の必要料金</th>
              <td>
                <ul>
                  <li>消費税（販売価格に消費税含む）</li>
                  <li>サイトの閲覧、コンテンツのダウンロード、お問い合わせ等の際の電子メールの送受信時などのインターネット接続に別途、ご契約の通信事業者への通信料が発生いたします。</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>引き渡し時期</th>
              <td>オンラインにおけるサービス利用（サービス利用開始後即時）</td>
            </tr>
            <tr>
              <th>お支払方法と期限</th>
              <td>クレジットカード（各カード会社別引き落とし日）</td>
            </tr>
            <tr>
              <th>返品・交換・キャンセル等</th>
              <td>オンラインサービスの性質上、返品は承っておりません。</td>
            </tr>
            <tr>
              <th>解約条件</th>
              <td>契約期間内であれば、いつでも解約することができます。解約いただくと次の契約更新日をもってサービス提供が終了し、請求を停止します。
                <br>
                解約はプロフィールページから行うことが可能です。
                <br>
                途中解約による返金は承っておりません。
              </td>
            </tr>
            <tr>
              <th>不良品の取扱条件</th>
              <td>現状有姿による利用となります。</td>
            </tr>
            <tr>
              <th>特別条件</th>
              <td>
                販売条件 未成年者の購入について お客様が未成年者の場合は、保護者の方の同意を得てからご購入ください。
                <br>
                特定商取引法に規定されるクーリング・オフが適用されるサービスではありません。
                <br>
                途中の解約となった場合も1ヶ月分の料金が発生し、日割精算等による返金を含めた一切の返金は行われません。
              </td>
            </tr>
          </table>
        </div>
      </div>
    </main>
    <FooterItem :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { Analytics/*, Logger*/ } from "aws-amplify"
import HeaderItem from './Header'
import FooterItem from './Footer'
import { Common } from './Common.js'

//const logger = new Logger('Law');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'Law',
  components: {
    HeaderItem,
    FooterItem
  },
  mixins:[Common],
  data() {
    return {
      contactUrl: '',
    }
  },

  mounted() {
    let env = this.getEnv(location.hostname)
    this.appClass = this.getAppDivClass(location.hostname)
    if (this.appClass === 'hama') {
      this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_env=' + env // 浜松オンラインがん相談版
    } else {
      this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_env=' + env // CancerWith版
    }
  },

  async beforeCreate() {
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Law',
        url: window.location.origin + window.location.pathname
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      this.$gtag.pageview({
        page_path: '/law',
        page_title: '特定商取引法に基づく表示 (/law)'
      })
    }
  }
}
</script>
